<!--缺票登记-->
<template>
    <el-drawer
        title="票品登记"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-alert type="warning" show-icon :closable="false" :title="`当前缺票: ${itemData && itemData.lackTicketsNum}人(登记过且仍然无票)`"></el-alert>
            <div class="MT20">
                当前票品售罄后，开启票品登记视为允许用户设置加票提醒。<br>
                加票后请在<router-link :to="`/activityManage/activity/edit/lackTicket/${activityId}`" class="color-theme">【票品登记】</router-link>页面发送通知
            </div>
            <el-form
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
                class="MT10"
            >
                <el-form-item prop="status">
                    <span slot="label">登记开关: </span>
                    <el-radio-group v-model="formDatas.status">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确 认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    status:1,
    ticketPriceId:''
}
export default {
    props:{
        activityId:{
            type:[Number,String],
            default:''
        },
    },
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas:{
                ...defaultFormData
            },
            rules:{
                
            },
            itemData: null
        }
    },
    methods:{
        close(){
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.formDatas = {
                ...defaultFormData
            }
        },
        show(itemData){
            this.itemData = itemData;
            this.formDatas.ticketPriceId = itemData.id;
            this.formDatas.status = itemData.isAddGoods || 0;
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/activity/saveTicketRecord',
                        params: {
                            ...this.formDatas,
                            activityId: this.activityId
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit("onUpdate");
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        },
    }
}
</script>